import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"

import { LocalizedEnum } from "../../../../../../modules/localization/components/AppLocalized"
import { SelectableRadioCard } from "../../../../selectableRadioCard/SelectableRadioCard"

import type { TakeawayPaymentMethod } from "../takeawayTypes"
import { toEnumKey } from "./takeawayCheckoutLib"
import { TakeawayPaymentMethodIcon } from "./TakeawayPaymentMethodIcon"

const useStyles = makeStyles()((theme) => ({
    name: {
        fontWeight: 400,
        color: theme.palette.tailwind.slate[900],
    },
    iconWrap: {
        width: "2.25rem",
        height: "2.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flexShrink: 0,
    },
    iconImg: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
}))

type TakeawayPaymentOptionProps = Readonly<{
    method: TakeawayPaymentMethod
    isSelected: boolean
    isDisabled: boolean
    nameOverride?: string
    onClick: () => void
}>

export function TakeawayPaymentOption({
    method,
    isSelected,
    isDisabled,
    nameOverride,
    onClick,
}: TakeawayPaymentOptionProps) {
    const { classes } = useStyles()

    return (
        <SelectableRadioCard
            isSelected={isSelected}
            isDisabled={isDisabled}
            onSelect={onClick}
            endAdornment={
                <Box className={classes.iconWrap}>
                    <TakeawayPaymentMethodIcon method={method} className={classes.iconImg} />
                </Box>
            }
        >
            {nameOverride ? (
                <Typography variant="body1" className={classes.name}>
                    {nameOverride}
                </Typography>
            ) : (
                <LocalizedEnum base="purchases-payment-method" enumValue={toEnumKey(method.value)}>
                    <Typography variant="body1" className={classes.name}>
                        {method.value}
                    </Typography>
                </LocalizedEnum>
            )}
        </SelectableRadioCard>
    )
}
